import { getFetcher } from 'utils/fetcher'
import { useQuery } from 'react-query'

export default function useCurrentUser() {
  return useQuery(`/users/current`, getFetcher, {
    staleTime: 3 * 60*1000 //3min
  });
}